<template>
  <div class="messages-main-container">
    <p class="messages-label">Czat/notatki</p>
    <dod-chat-tabs @tabChange="handleChangeChatTab" />
    <div class="messages" id="dod-user-messages">
      <dod-chat-message
        v-for="message in messages.data"
        :key="message.id"
        :message="message"
        @messageDeleted="handleMessageDeleted"
        @editMessage="handleEditMessage"
        @attachmentRemoved="handleAttachmentRemoved"
      />
      <!-- <dod-custom-textarea
        placeholder="Twoja wiadomość..."
        :rowsNumber="5"
        style="margin-top: auto"
        :handleEnterAction="handleNewMessage"
        @change="(e) => (message = e)"
      /> -->

      <html-editor-with-mentions
        v-if="selectedTab !== 'Aktywność'"
        :key="`newDodMessageEditor${newMessageRefresh}`"
        :editorId="'newDodMessageEditor'"
        @contentchanged="handleHtmlEditorContent($event)"
        :withoutAllReplacements="true"
        :startContent="message"
      />

      <input
        type="file"
        class="form-control"
        id="messages-files"
        name="file"
        multiple
        style="display: none"
        @change="handleFiles"
      />
      <div class="selected-files" v-if="files && files.length > 0">
        <p class="pt-0"><b>Załączniki</b></p>
        <p class="selected-file" v-for="file in files" :key="file.name">
          <span>{{ file.name }}</span>
          <svg
            class="cursor-pointer ml-3"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            @click="removeFile(file)"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="#EC0909"
              stroke-width="1.5"
            />
            <path
              d="M14.5 9.5L9.5 14.5M9.49998 9.49998L14.5 14.5"
              stroke="#EC0909"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        </p>
      </div>
      <button
        :disabled="loading"
        @click="selectAttachments"
        class="btn btn-outline-dark"
      >
        Dodaj załączniki
      </button>

      <gradient-button
        :disabled="loading"
        v-if="selectedTab !== 'Aktywność'"
        @handleClick="handleNewMessage(message)"
        :title="'Wyślij'"
        :customStyles="'width: 100%; height: 40px; max-height: 40px;font-size: 15px'"
      />
    </div>
  </div>
</template>

<script>
import HtmlEditorWithMentions from "../HtmlEditorWithMentions.vue";
import DodChatMessage from "./DodChatMessage.vue";
import DodChatTabs from "./DodChatTabs.vue";
import GradientButton from "./GradientButton.vue";
//import DodCustomTextarea from "./DodCustomTextarea.vue";
export default {
  name: "UserMessages",
  components: {
    //DodCustomTextarea,
    DodChatMessage,
    DodChatTabs,
    HtmlEditorWithMentions,
    GradientButton,
  },
  props: ["employeeId", "customerId"],

  async mounted() {
    if (this.employeeId) {
      await this.fetchEmployeeMessages();
    } else {
      await this.fetchCustomerMessages();
    }
  },
  data() {
    return {
      message: "",
      newMessageRefresh: false,
      selectedTab: "Wszystko",
      files: [],
      loading: false,
    };
  },
  methods: {
    removeFile(file) {
      this.files = this.files.filter((f) => f.name !== file.name);
    },
    handleFiles(e) {
      this.files = [...this.files, ...e.target.files];
    },

    selectAttachments() {
      document.getElementById("messages-files").click();
    },
    async handleEditMessage(data) {
      const response = await this.$store.dispatch("editMessage", data);
      if (response) {
        if (this.employeeId) {
          await this.fetchEmployeeMessages(this.selectedTab);
        } else {
          await this.fetchCustomerMessages(this.selectedTab);
        }
      }
    },
    handleHtmlEditorContent(content) {
      this.message = content;
    },
    async handleMessageDeleted(messageId) {
      const response = await this.$store.dispatch("deleteMessage", messageId);
      if (response) {
        if (this.employeeId) {
          await this.fetchEmployeeMessages(this.selectedTab);
        } else {
          await this.fetchCustomerMessages(this.selectedTab);
        }
      }
    },
    async handleChangeChatTab(selectedTab) {
      if (this.employeeId) {
        await this.fetchEmployeeMessages(selectedTab);
      } else {
        await this.fetchCustomerMessages(selectedTab);
      }
      this.selectedTab = selectedTab;
    },
    async fetchEmployeeMessages(selectedTab) {
      await this.$store.dispatch("getEmployeeMessages", {
        employeeId: this.employeeId,
        selectedTab,
      });
    },
    async fetchCustomerMessages(selectedTab) {
      await this.$store.dispatch("getCustomerMessages", {
        customerId: this.customerId,
        selectedTab,
      });
    },

    async handleAttachmentRemoved() {
      if (this.employeeId) {
        await this.fetchEmployeeMessages(this.selectedTab);
      } else {
        await this.fetchCustomerMessages(this.selectedTab);
      }
    },

    async handleNewMessage(message) {
      try {
        this.loading = true;
        if (message === "") {
          this.$notify({
            group: "error",
            text: "Wiadomośc nie może być pusta ",
          });
          return;
        }

        let addedFilesIds = [];
        for await (let fileToAdd of this.files) {
          const fileId = await this.$store.dispatch("addDodFile", {
            file: fileToAdd,
          });
          addedFilesIds.push(fileId);
        }

        if (this.employeeId) {
          await this.$store.dispatch("addMessage", {
            text: message,
            admin: this.admin.phone,
            type: "EMPLOYEE",
            customerId: "",
            employeeId: this.employeeId,
            taskId: null,
            isAction: false,
            filesIds: addedFilesIds,
          });
          await this.fetchEmployeeMessages();
          this.message = "";
          this.newMessageRefresh = !this.newMessageRefresh;
        }
        if (this.customerId) {
          await this.$store.dispatch("addMessage", {
            text: message,
            admin: this.admin.phone,
            type: "CUSTOMER",
            customerId: this.customerId,
            employeeId: "",
            taskId: null,
            isAction: false,
            filesIds: addedFilesIds,
          });
          await this.fetchCustomerMessages();
          this.message = "";
          this.newMessageRefresh = !this.newMessageRefresh;
        }
        this.files = [];
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },

  updated() {
    const messagesWrapperNode = document.querySelector(".messages");
    if (messagesWrapperNode) {
      setTimeout(() => {
        messagesWrapperNode.scroll({
          behavior: "smooth",
          left: 0,
          top: messagesWrapperNode.scrollHeight,
        });
      }, 500);
    }
  },

  computed: {
    messages() {
      if (this.employeeId) {
        return this.$store.getters.getDodSelectedEmployeeMessages;
      } else {
        return this.$store.getters.getDodSelectedCustomerMessages;
      }
    },
    admin() {
      return this.$store.getters.getLoggedAdmin;
    },
  },
};
</script>
<style scoped>
.messages-main-container {
  margin-top: 4rem;
  width: 100%;
}
.messages {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
  padding: 1rem;
  border-radius: 8px;
  border: 0.5px solid rgba(9, 7, 65, 0.25);
  background: #fff;
  box-shadow: 0px 4px 15px 0px rgba(96, 108, 128, 0.25);
  min-height: 180px;
  max-height: 700px;
}
.messages-label {
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #e2037e;
  text-align: center;
}
.selected-file {
  display: flex;
  align-items: center;
}
</style>
